module.exports = __webpack_public_path__ + "img/contacto_16-9_1440.eba9b9ed.webp";